module.exports = __webpack_public_path__ + "img/pic_05.b34b6218.svg";